<section class="child">
    <nav>
        <c-offline-form-message/>
    </nav>
</section>
<section class="child">
    <nav>
        <c-tree-explorer config="navigationLinksConfig"></c-tree-explorer>
    </nav>
</section>
<section class="child">
    <nav>
        <c-tree-explorer config="transcriptLinksConfig"></c-tree-explorer>
    </nav>
</section>